import { Content } from "@/src/components/wrappers/Content";
import { CurrenciesTable } from "./CurrenciesTable";
import { ActionsContext } from "@/src/lib/actions";
import { SyncRatesButton } from "./SyncRatesButton";
import { CalculatorButton } from "./CalculatorButton";
import { Footer } from "@/src/components/ui/footer";

export function Currencies() {
  return (
    <ActionsContext>
      <Content
        title="Currencies"
        contentAction={
          <div className="flex gap-6">
            <CalculatorButton />
            <SyncRatesButton />
          </div>
        }
      >
        <CurrenciesTable />
        <Footer />
      </Content>
    </ActionsContext>
  );
}
